import React from 'react';
import { Box, Button } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import CreateIcon from '@material-ui/icons/Create';

const PermitCardActions = ({
  isEditing,
  onEdit,
  onCancel,
  onSave,
  showActions,
  submitDisabled,
  editButtonId,
  saveButtonId,
  cancelButtonId,
}) => {
  if (!showActions) {
    return null;
  }

  if (!isEditing) {
    return (
      <Box px={1.5} pt={0.5} pb={1}>
        <Button
          id={editButtonId}
          type="button"
          variant="contained"
          color="primary"
          size="small"
          fullWidth
          startIcon={<CreateIcon fontSize="small" />}
          onClick={onEdit}
        >
          Edit
        </Button>
      </Box>
    );
  }

  return (
    <Box px={1.5} pb={1} display="flex" alignItems="center">
      <Button
        id={cancelButtonId}
        type="button"
        variant="outlined"
        color="primary"
        size="small"
        style={{ minWidth: 72, flexShrink: 0 }}
        onClick={onCancel}
        disabled={submitDisabled}
      >
        Cancel
      </Button>
      <Box ml={1} flex={1}>
        <Button
          id={saveButtonId}
          type="button"
          variant="contained"
          color="primary"
          size="small"
          fullWidth
          startIcon={<CheckIcon fontSize="small" />}
          onClick={onSave}
          disabled={submitDisabled}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default PermitCardActions;
